import { Component, Input, OnInit } from '@angular/core';
import { Container } from 'ng-particles';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Component({
  selector: 'particles',
  templateUrl: './particles.component.html',
  styleUrls: ['./particles.component.scss']
})
export class ParticlesComponent implements OnInit {

  particlesOptions: any;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.getJSON().subscribe(data => {
      this.particlesOptions = data;
     });
  }

  public getJSON(): Observable<any> {
    return this.http.get('assets/particles/default.json');
  }

  particlesLoaded(container: Container): void {
    console.log(container);
  }

}
